export async function reportErrorAPI(formData) {
    const response = await fetch(
        `${process.env.REACT_APP_BACKEND_MACHINE}/api/report-content-error`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: formData,
        }
    );

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error reporting the error: ${errorData.message}`);
    }

    const data = await response.json();
    return data.message;
}
